<!--
STEPPER 기능 구현 mixin
모달창 내에서 단계별로 진행되는 레이아웃을 구현하기 위한 기능 모음.
------------------------------------
사용법
1. steps, currStep 필드 각 사용컴포넌트에서 재정의
2. 단계별 레이아웃 (visible or unvisible) 이 적용될 html 엘리먼트에 v-if 디렉티브 설정
   (여러 단계인경우, 배열로 정의)

   e.g. <div v-if="stepIn('step-input')">1단계 화면</div>
   e.g. <div v-if="stepIn('step-confirm')">2단계 화면</div>
   e.g. <div v-if="stepIn(['step-input', 'step-confirm'])">1단계,2단계 화면</div>


-->

<script>
    export default {
        data: function () {
            return {
                // (string) 현재 진행단계
                currStep: 'step-input',

                // (array) 진행단계 코드 배열
                steps: [
                    'step-input',
                    'step-confirm',
                    'step-done',
                ],



            };
        },

        methods: {
            /**
             * 현재스텝이 주어진 단계에 해당하는지 여부
             * @param steps (array|string) 여러단계인경우 배열로전달
             * @return bool
             */
            stepIn(steps) {
                // 문자열인경우 배열에 담기
                if (! Array.isArray(steps)) {
                    steps = [steps];
                }

                return _.includes(steps, this.currStep);
            },

            /**
             * 현재스텝이 주어진 단계에 해당안하면 true
             * @param steps (array|string) 여러단계인경우 배열로전달
             * @return bool
             */
            stepNotIn(steps) {
                // 문자열인경우 배열에 담기
                if (! Array.isArray(steps)) {
                    steps = [steps];
                }

                return ! _.includes(steps, this.currStep);
            },

            /**
             * 단계변경
             * @param step
             */
            changeStep(step) {
                this.currStep = step;
            }
        },

    }
</script>